// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--gFo_J","link":"_93444fe79c--link--vgP4v"};